import Image from "next/image";
import React, { FC } from "react";

interface InfoCardProps {
  icon: string;
  index?: Number;
  title: string;
  description: string;
}

const InfoCard: FC<InfoCardProps> = ({ icon, index, title, description }) => {
  return (
    <div className=" mb-16 lg:mb-0">
      <div className="relative overflow-y-hidden h-12 sm:h-20">
        <Image
          src={`/icons/${icon}`}
          layout="fill"
        />
      </div>
      {index && (
        <div className="custom-shadow-1 w-8 h-8 sm:h-10 sm:w-10 rounded-full flex items-center justify-center mx-auto mt-4 sm:mt-8">
          {index.toString()}
        </div>
      )}
      <div className="w-full text-center mt-4 lg:mt-8">
        <p className="caption-gray font-semibold text-xl sm:text-2xl">{title}</p>
        <p className="sm:font-thin text-sm sm:text-2xl future-text-gray w-3/4 2xl:w-7/12 mx-auto mt-4">
          {description}
        </p>
      </div>
    </div>
  );
};

export default InfoCard;
